/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Speciallist_Charm1Inputs */

const id_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor Star Wars klasik, dibayangkan ulang dalam gaya unik LEGO.`)
};

const ms_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor Star Wars klasik, diimajinasikan semula dalam gaya unik LEGO.`)
};

const da_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klassisk Star Wars-humor, genopfundet i LEGO's unikke stil.`)
};

const de_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klassischer Star Wars-Humor, neu interpretiert im einzigartigen LEGO-Stil.`)
};

const en_us2_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Classic Star Wars humor, reimagined in LEGO's unique style.`)
};

const es_es2_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor clásico de Star Wars, reimaginado al estilo único de LEGO.`)
};

const es_mx2_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor clásico de Star Wars, reimaginado al estilo único de LEGO.`)
};

const fil_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Klasikong Star Wars humor, muling inimaginar sa natatanging istilo ng LEGO.`)
};

const fr_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong} : L'humour classique de Star Wars réimaginé dans le style unique LEGO.`)
};

const it_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Umorismo classico di Star Wars, reimmaginato nello stile unico di LEGO.`)
};

const hu_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Klasszikus Star Wars humor, LEGO egyedi stílusában újragondolva.`)
};

const nl_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Klassieke Star Wars-humor, heruitgevonden in LEGO's unieke stijl.`)
};

const no_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Klassisk Star Wars-humor, gjenskapt i LEGOs unike stil.`)
};

const pl_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klasyczny humor Gwiezdnych Wojen, odtworzony w unikalnym stylu LEGO.`)
};

const pt_br2_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor clássico Star Wars, reimaginado no estilo único de LEGO.`)
};

const pt_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Humor clássico de Star Wars, reimaginado no estilo único LEGO.`)
};

const ro_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Umorul clasic Star Wars, reimaginat în stilul unic LEGO.`)
};

const fi_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klassinen Star Wars -huumori, kuviteltu uudelleen LEGOn ainutlaatuisella tyylillä.`)
};

const sv_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klassisk Star Wars-humor, nytänkt i LEGOs unika stil.`)
};

const vi_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Hài hước Star Wars cổ điển, được tái hiện theo phong cách LEGO độc đáo.`)
};

const tr_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: LEGO'nun benzersiz tarzıyla yeniden tasarlanan klasik Star Wars mizahı.`)
};

const cs_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Klasický humor Star Wars, přepracovaný v jedinečném stylu LEGO.`)
};

const bg_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Класически Star Wars хумор, преосмислен в уникалния стил на LEGO.`)
};

const ru_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Классический юмор Star Wars, переосмысленный в уникальном стиле LEGO.`)
};

const uk_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: Класичний гумор Star Wars, переосмислений в унікальному стилі LEGO.`)
};

const ar_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: فكاهة Star Wars الكلاسيكية، معاد تصورها بأسلوب LEGO الفريد.`)
};

const hi_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: LEGO आकर्षण।`)
};

const th_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: อารมณ์ขันสไตล์ Star Wars คลาสสิก ถูกนำเสนอใหม่ในสไตล์ LEGO ที่ไม่เหมือนใคร`)
};

const ja_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}：クラシックな Star Wars ユーモアを LEGO のユニークなスタイルで再構築。`)
};

const zh_cn2_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}：经典的星球大战幽默，以乐高独特风格重新演绎。`)
};

const zh_hant1_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: 經典星際大戰幽默，以 LEGO 獨特風格重新演繹。`)
};

const ko_misc_posts_speciallist_charm1 = /** @type {(inputs: Misc_Posts_Speciallist_Charm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🏗️ ${i?.strong}: 클래식 스타워즈 유머, LEGO만의 독특한 스타일로 재해석.`)
};

/**
* | output |
* | --- |
* | "🏗️ {strong}: Classic Star Wars humor, reimagined in LEGO's unique style." |
*
* @param {Misc_Posts_Speciallist_Charm1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_charm1 = /** @type {((inputs: Misc_Posts_Speciallist_Charm1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Charm1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_charm1(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_charm1(inputs)
	if (locale === "da") return da_misc_posts_speciallist_charm1(inputs)
	if (locale === "de") return de_misc_posts_speciallist_charm1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_charm1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_charm1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_charm1(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_charm1(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_charm1(inputs)
	if (locale === "it") return it_misc_posts_speciallist_charm1(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_charm1(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_charm1(inputs)
	if (locale === "no") return no_misc_posts_speciallist_charm1(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_charm1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_charm1(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_charm1(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_charm1(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_charm1(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_charm1(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_charm1(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_charm1(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_charm1(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_charm1(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_charm1(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_charm1(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_charm1(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_charm1(inputs)
	if (locale === "th") return th_misc_posts_speciallist_charm1(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_charm1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_charm1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_charm1(inputs)
	return ko_misc_posts_speciallist_charm1(inputs)
});
export { misc_posts_speciallist_charm1 as "misc.posts.specialList.charm" }